import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import GenericPromises from '../../../../../api/GenericPromises';
import useSnackBar from '../../../../../components/Commons/SnackBar/useSnackBar';
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { Spinner } from '../../../../../components/Commons/Spinner/Spinner';
import { ButtonLoading, ButtonStyled, PrimaryButton } from '../../../../../theme/buttons';
import { useBase64 } from '../../../../../hooks/useBase64';
import { Group } from '../../../../../interfaces/Security/groups';

export const DeleteMenu = ({ ...props }) => {
    const [t] = useTranslation("global");
    const { GenericGetResource, GenericDeleteResource } = GenericPromises();
    const [comboGroups, setComboGroups] = useState<Group[]>([]);
    const [loadingPost, setLoadingPost] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const { showSnackBar, SnackbarComponent } = useSnackBar();
    const { utf8ToBase64 } = useBase64();


    const onDelete = () => {
        if (!(comboGroups.length > 0)) {
            setLoadingPost(true);
            props.setIsLoadingAction(true);
            GenericDeleteResource(`/optionmenu/${props.myEnumValue?.enum_id}`)
                .then((response) => {
                    setComboGroups([]);
                    let myComboEnum = props.comboEnum.filter((element: any) => element.enum_id !== props.myEnumValue?.enum_id);
                    props.setComboEnum(myComboEnum);
                    setLoadingPost(false);
                    props.setMyEnumValue(props.comboEnum[0]);
                    props.setIsLoadingAction(false);
                    showSnackBar(t("generic.snackbar.delete"), "success");
                    onCancel();
                })
                .catch((error) => {
                    props.setIsLoadingAction(false);
                    setLoadingPost(false);
                    showSnackBar(error.message, 'error');
                });
        }
    }

    const onCancel = () => {
        props.setOpenDialog(false);
    }

    useEffect(() => {
        setComboGroups([]);
        GenericGetResource(`/groups?filter=${utf8ToBase64(`option_menu_id=${props.myEnumValue?.enum_id}`)}`).then((responseGroup) => {
            setComboGroups(responseGroup.data.data);
            setDataLoaded(true);
        }).catch((error) => {
            onCancel();
        })
    }, []);

    return (
        <>
            {!dataLoaded && <Spinner isBox={false} />}
            {dataLoaded &&
                <Box className='d-flex justify-content-center' sx={{ minWidth: 1000 }}>
                    <div className="w-100">
                        <div className="w-100">

                            <Typography>{t("optionsmenu.dialog.delete_menu")}</Typography>

                        </div>
                        <Box className='d-flex flex-row justify-content-end' sx={{ minWidth: 1000 }}>

                            <ButtonStyled variant='contained' className='m-1' onClick={onCancel} disabled={loadingPost}>{t("generic.buttons.cancel")}</ButtonStyled>
                            <ButtonLoading onClick={() => { onDelete() }} variant='outlined' className='m-1' disabled={loadingPost ? true : comboGroups.length > 0} isLoading={loadingPost}>{t("optionsmenu.actions.delete_menu")}</ButtonLoading>

                        </Box >
                    </div>
                </Box >
            }
            <SnackbarComponent />
        </>
    )
}
